module.exports = __webpack_public_path__ + "img/template3.d1d57b37.jpg";